import service from './service'
import Qs from 'qs'


const PRODUCT_ID = 2
export function getContent(body) {
    return service.post('/web/getContent', Qs.stringify(body))
}

export function addMessage(lang, name, company, phone, email, title, content, productId = PRODUCT_ID) {
    return service.post('/web/addMessage', Qs.stringify({ lang, name, company, phone, email, title, content, productId }))

}

export function addTrial(email, productId = PRODUCT_ID) {
    return service.post('/web/addTrial', Qs.stringify({ email, productId }))
}
export function downInstallPackage(versionId, lang, bit, productId = PRODUCT_ID) {
    return service.post('/web/downInstallPackage', Qs.stringify({ versionId, lang, bit, productId }))
}

export function getProductPrice(versionId, lang, productId = PRODUCT_ID) {
    return service.post('/web/getProductPrice', Qs.stringify({ versionId, lang, productId }))
}

export function searchLanguage(pageNo, pageSize, productId = PRODUCT_ID) {
    return service.post('/web/searchLanguage', Qs.stringify({ pageNo, pageSize, productId }))
}


// WEBPACK FOOTER //
// ./src/utils/http/loadData.js